<div class="page-404-container">
  <img [src]="imageUrl" alt="404" class="page-404-image" cpakErrorImage />
  <div class="page-404-title">{{ 'page404Text' | transloco }}</div>
  <p class="page-404--description">{{ 'page404Description' | transloco }}</p>
  <button
    pButton
    type="button"
    [label]="'page404RedirectToDashboard' | transloco"
    [routerLink]="['/' + dashboardLink]"
    class="p-button primary-button p-button-rounded page-404-button"
  ></button>
</div>
